/**
 * Constants shared by DefineDecompositionTabs and consumers.
 * Lives in its own file so DefineDecompositionTabs.jsx exports ONLY the
 * component (satisfies react-refresh/only-export-components).
 *
 * Step 4 — Define Decomposition view-switcher.
 */

export const DECOMPOSITION_VIEW_MODES = ['domains', 'services', 'graph', 'list']
export const DEFAULT_DECOMPOSITION_VIEW_MODE = 'domains'
